import React, { useContext, useEffect, useState } from "react";
import EventCard from "../../components/rj-components/EventCard";
import { Row, Col } from "react-bootstrap";
import BasicHeader from "../../components/headers/BasicHeader";
import GlobalContext from "../../contexts/store";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";



function EventList() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { events, organizations } = useContext(GlobalContext);
  const [orgsWithEvents, setOrgsWithEvents] = useState([]);
  const [pageEvents, setPageEvents] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);



  useEffect(() => {
    if (organizations.length < 1 || events.length < 1) {
      return;
    }
    // Filter organizations with upcoming events and add their events
    const orgsWithEvents = organizations
      .filter(org => events.some(event => event.organization._id === org._id || event.organization._id === '651a34f501ac2f354a663e65'))
      .map(org => ({
        ...org,
        events: events.filter(event => event.organization._id === org._id || event.organization._id === '651a34f501ac2f354a663e65')
      }));


    const orgsWithEventsFiltered = orgsWithEvents.filter(org => org.slug === slug)

    setOrgsWithEvents(orgsWithEventsFiltered);
    setPageEvents(orgsWithEventsFiltered[0]?.events || []);
    window.scrollTo(0, 0);
  }, [events, organizations, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#101010]">
      <BasicHeader title={`${orgsWithEvents[0]?.name || 'Events'}`} byline={`${orgsWithEvents[0]?.name ? 'Events' : ''}`} image={'https://sfclubs.s3.us-west-1.amazonaws.com/galleryItems/1741302612162_IMGL0009_Large.jpeg'} />
      {pageEvents && pageEvents.length === 0 && (
        <div className="flex flex-col items-center justify-center min-h-[300px]">
          <p className="text-white text-center text-[20px] font-bold">No events found at this time. Please check back later.</p>
          <Button variant="primary" text="Go To Home" onClick={() => navigate('/')} />
        </div>
      )}
      <div className={`pt-0 ${isMobile ? 'mt-[150px]' : 'mt-[100px]'} flex flex-col justify-center items-center`}>
        {isMobile ? (
          <div className="flex flex-col items-center w-full">
            {pageEvents && pageEvents.length > 0 && pageEvents.map((event, index) => (
              <div key={index} className="flex justify-center w-full">
                <Link to={`/events/event/${event?.slug}`}>
                  <EventCard event={event} />
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <div className="w-full max-w-[1200px] px-4">
            <Row className="">
              {pageEvents && pageEvents.length > 0 && pageEvents.map((event, index) => (
                <Col lg={4} md={6} key={index}>
                  <Link to={`/events/event/${event?.slug}`}>
                    <EventCard event={event} />
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventList;
